// extracted by mini-css-extract-plugin
export var legendIndicator = "_fb-1";
export var legendRight = "_fb-0";